module.exports = __webpack_public_path__ + "circle_check_primary.png";